/*
  Page-interaction analytics for the nav-graph app (launchpad task appaman-nav-dropoff).
  Sends through window.mvTrack (snippets/posthog.liquid), so it obeys the same consent gate and the
  ?internal=1 flag. Nothing here reads what a shopper types: form fields report only that they were
  used and whether they were left filled.

  Events (all carry `section` = the page section the element sits in, when there is one):
    section_viewed        a page block first became at least 40% visible (or filled 40% of the screen). Blocks are
                          the page's sections plus the named parts inside them (BEM `x__y` classes, fold-out
                          panels, headed groups), so a product page reports photos, colours, spec table…
    details_toggled       a fold-out panel (<details>) was opened or closed
    gallery_view_changed  a product photo was chosen in the strip (Front / Back / Side / Worn …)
    color_chosen          a colour swatch was chosen on a product page
    portfolio_opened      a "Worn" portfolio frame was opened
    catalog_filter_changed  the collection Style / Size / Sort control changed (value + products shown)
    carousel_scrolled     a sideways-scrolling strip settled at a new position (index, of)
    field_used            a form field was left: filled or empty (never its value)
    page_engagement       once per page, on leave: max scroll, active time, per-section visible time,
                          sections seen in order, photo views, carousels' furthest position
*/
(function () {
  if (window.__mvInsight) return; window.__mvInsight = true;
  var track = function (n, p, o) { try { window.mvTrack && window.mvTrack(n, p || {}, o); } catch (e) {} };
  var t0 = Date.now();
  var clip = function (s, n) { s = String(s || '').replace(/\s+/g, ' ').trim(); return s.length > (n || 60) ? s.slice(0, n || 60) : s; };

  // ---- sections: a readable name for each .shopify-section
  function sectionName(sec) {
    if (!sec) return '';
    if (sec.dataset.mvName) return sec.dataset.mvName;
    var id = (sec.id || '').replace(/^shopify-section-/, '');
    var kind = id.split('__').pop().replace(/_[A-Za-z0-9]{6,}$/, '');
    var first = sec.querySelector(':scope > :not(script):not(style):not(link)');
    var cls = first && first.classList[0] ? first.classList[0] : '';
    var h = sec.querySelector('h1, h2, h3');
    var name = clip([kind, cls && cls !== kind ? cls : '', h ? '“' + clip(h.textContent, 28) + '”' : ''].filter(Boolean).join(' '), 70);
    sec.dataset.mvName = name;
    return name;
  }
  var sectionOf = function (el) { return sectionName(el && el.closest && el.closest('.shopify-section')); };

  function blockName(el) {
    if (el.classList.contains('shopify-section')) return sectionName(el);
    if (el.dataset.mvName) return el.dataset.mvName;
    var cls = [].slice.call(el.classList).filter(function (c) { return /__/.test(c); })[0] || el.classList[0] || el.tagName.toLowerCase();
    var h = el.tagName === 'DETAILS' ? el.querySelector('summary') : el.querySelector('h1, h2, h3, h4, summary, legend, .w-caps');
    var name = clip(cls + (h ? ' “' + clip(h.textContent, 30) + '”' : ''), 70);
    el.dataset.mvName = name;
    return name;
  }
  var secs = [], seen = [], visibleMs = {}, visibleSince = {};
  function initSections() {
    var all = [].slice.call(document.querySelectorAll('.shopify-section, .shopify-section [class*="__"], .shopify-section details'));
    secs = all.filter(function (s) {
      if (s.offsetHeight < 60 || s.offsetWidth < 120) return false;
      if (s.classList.contains('shopify-section')) return true;
      return /__/.test(s.className) ? !/__(in|inner|wrap|row|col|cell|item|link|label|img|cap)\b/.test(s.className) : s.tagName === 'DETAILS';
    }).slice(0, 60);
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      var now = Date.now();
      entries.forEach(function (e) {
        var name = blockName(e.target);
        var share = e.intersectionRatio, fills = e.intersectionRect.height / (window.innerHeight || 1);
        var on = e.isIntersecting && (share >= 0.4 || fills >= 0.4);
        if (on && !visibleSince[name]) {
          visibleSince[name] = now;
          if (seen.indexOf(name) < 0) {
            seen.push(name);
            track('section_viewed', { section: name, index: secs.indexOf(e.target), of: secs.length, order: seen.length, ms_since_load: now - t0 });
          }
        } else if (!on && visibleSince[name]) {
          visibleMs[name] = (visibleMs[name] || 0) + (now - visibleSince[name]); delete visibleSince[name];
        }
      });
    }, { threshold: [0, 0.2, 0.4, 0.6, 0.8, 1] });
    secs.forEach(function (s) { io.observe(s); });
  }

  // ---- scroll depth and active time
  var maxScroll = 0, activeMs = 0, lastActive = Date.now(), hidden = document.visibilityState === 'hidden';
  function onScroll() {
    var h = Math.max(document.documentElement.scrollHeight - window.innerHeight, 1);
    maxScroll = Math.max(maxScroll, Math.min(100, Math.round(100 * (window.scrollY || 0) / h)));
  }
  function tick() { var now = Date.now(); if (!hidden && now - lastActive < 30000) activeMs += Math.min(now - lastActive, 1000); }
  setInterval(tick, 1000);
  ['scroll', 'pointerdown', 'keydown', 'touchstart', 'mousemove'].forEach(function (ev) {
    window.addEventListener(ev, function () { lastActive = Date.now(); if (ev === 'scroll') onScroll(); }, { passive: true });
  });

  // ---- product photos, swatches, portfolio
  var photoViews = [];
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('button, a, [role="button"]');
    if (!t) return;
    var strip = t.closest('[data-strip]');
    if (strip) {
      var btns = [].slice.call(strip.querySelectorAll('button, a, [role="button"]'));
      var label = clip(t.getAttribute('aria-label') || t.textContent, 30);
      photoViews.push(label);
      track('gallery_view_changed', { view: label, index: btns.indexOf(t), of: btns.length, section: sectionOf(t), nth_change: photoViews.length });
      return;
    }
    if (t.closest('[data-swatches]')) { track('color_chosen', { color: clip(t.getAttribute('aria-label') || t.title || t.textContent, 30), section: sectionOf(t) }); return; }
    if (t.closest('[data-folio-color]') || t.hasAttribute('data-folio-color')) { track('portfolio_opened', { color: t.getAttribute('data-folio-color') || '', section: sectionOf(t) }); }
  }, true);

  // ---- fold-out panels
  document.addEventListener('toggle', function (e) {
    var d = e.target; if (!d || d.tagName !== 'DETAILS') return;
    var sm = d.querySelector('summary');
    track('details_toggled', { panel: clip(sm ? sm.textContent : blockName(d), 40), open: d.open, section: sectionOf(d) });
  }, true);

  // ---- collection filters (works-catalog.js): Style / Size / Sort
  document.addEventListener('change', function (e) {
    var f = e.target, form = f.closest && f.closest('[data-catalog-filters]');
    if (!form) return;
    setTimeout(function () { // after works-catalog.js has re-filtered
      var shown = [].slice.call(document.querySelectorAll('[data-catalog] [data-product]')).filter(function (c) { return !c.hidden; }).length;
      track('catalog_filter_changed', { field: f.name, value: f.value || '(any)', style: form.elements.style && form.elements.style.value, size: form.elements.size && form.elements.size.value, sort: form.elements.sort && form.elements.sort.value, shown: shown, section: sectionOf(form) });
    }, 0);
  }, true);

  // ---- sideways strips (header departments, PDP photo strip on phones, any overflow-x list)
  var carouselMax = {};
  function carouselName(el) { return clip((el.getAttribute('aria-label') || el.className || el.tagName).toString().split(' ')[0], 40); }
  var timers = new WeakMap();
  document.addEventListener('scroll', function (e) {
    var el = e.target;
    if (!el || el === document || !el.scrollWidth || el.scrollWidth <= el.clientWidth + 8) return;
    clearTimeout(timers.get(el));
    timers.set(el, setTimeout(function () {
      var kids = el.children.length || 1, w = el.scrollWidth / kids;
      var idx = Math.round(el.scrollLeft / Math.max(w, 1)), name = carouselName(el);
      if (carouselMax[name] == null || idx > carouselMax[name]) carouselMax[name] = idx;
      track('carousel_scrolled', { carousel: name, index: idx, of: kids, pct: Math.round(100 * el.scrollLeft / Math.max(el.scrollWidth - el.clientWidth, 1)), section: sectionOf(el) });
    }, 400));
  }, true);

  // ---- form fields: used, left filled or empty (no values)
  document.addEventListener('focusout', function (e) {
    var f = e.target;
    if (!f || !/^(INPUT|TEXTAREA|SELECT)$/.test(f.tagName) || f.closest('[data-catalog-filters]')) return;
    if (/^(hidden|submit|button|checkbox|radio|range|file)$/.test(f.type)) return;
    var lab = f.getAttribute('aria-label') || f.name || f.placeholder || f.id || f.type;
    track('field_used', { field: clip(lab, 40), type: f.type || f.tagName.toLowerCase(), filled: !!(f.value && String(f.value).trim()), section: sectionOf(f) });
  }, true);

  // ---- one summary per page
  var sent = false;
  function summary() {
    if (sent) return; sent = true; tick();
    var now = Date.now();
    Object.keys(visibleSince).forEach(function (k) { visibleMs[k] = (visibleMs[k] || 0) + (now - visibleSince[k]); });
    var per = {}; Object.keys(visibleMs).forEach(function (k) { per[k] = Math.round(visibleMs[k] / 100) / 10; });
    track('page_engagement', {
      max_scroll_pct: maxScroll, active_s: Math.round(activeMs / 1000), total_s: Math.round((now - t0) / 1000),
      sections_seen: seen, sections_total: secs.length, section_visible_s: per,
      photo_views: photoViews.slice(0, 30), carousels_max_index: carouselMax,
      viewport_w: window.innerWidth, viewport_h: window.innerHeight, page_h: document.documentElement.scrollHeight
    }, { transport: 'sendBeacon' });
  }
  window.addEventListener('pagehide', summary);
  document.addEventListener('visibilitychange', function () {
    hidden = document.visibilityState === 'hidden';
    if (hidden) summary(); // phones often never fire pagehide
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initSections(); onScroll(); });
  else { initSections(); onScroll(); }
})();
